<template>
  <div class="home-page">
    <Header :active-nav="activeNav" @nav-click="scrollToSection" />

    <!-- 轮播图 -->
    <Carousel :slides="slides" />

    <!-- 内容区域 -->
    <ContentSection />

    <!-- 底部信息 -->
    <Footer @scroll-to="scrollToSection" @show-product="showProduct" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Carousel from "@/components/Carousel.vue";
import ContentSection from "@/components/ContentSection.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Carousel,
    ContentSection,
    Footer,
  },
  data() {
    return {
      activeNav: "home",
      slides: [
        {
          title: "创新引领未来",
          description:
            "太丰集团致力于高新技术研发，以创新驱动企业可持续发展，为客户创造更大价值。",
          image:
            "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
        },
        {
          title: "智能制造专家",
          description:
            "我们提供全面的工业自动化解决方案，帮助客户提高生产效率，降低运营成本。",
          image:
            "https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
        },
        {
          title: "绿色环保先行者",
          description:
            "太丰环保材料通过国际环保认证，为建筑行业提供可持续的绿色解决方案。",
          image:
            "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
        },
        {
          title: "全球合作伙伴",
          description:
            "我们的产品和服务已经覆盖全球30多个国家和地区，与世界500强企业建立长期合作关系。",
          image:
            "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.updateActiveNav);

    this.checkUrlScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.updateActiveNav);
  },
  methods: {
    updateActiveNav() {
      // const scrollPosition = window.scrollY + 100;
      // const sections = ["home", "about", "products", "company", "contact"];
      // const sectionOffsets = sections.map((section) => {
      //   const element = document.getElementById(section);
      //   return element ? element.offsetTop : 0;
      // });
      // for (let i = sections.length - 1; i >= 0; i--) {
      //   if (scrollPosition >= sectionOffsets[i]) {
      //     this.activeNav = sections[i];
      //     break;
      //   }
      // }
    },
    checkUrlScroll() {
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get("scrollTo"); // 获取参数的值
      this.scrollToSection(paramValue);
    },
    scrollToSection(sectionId) {
      this.activeNav = sectionId;

      const element = document.getElementById(sectionId);
      const rect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const elementPosition = rect.top + scrollTop;

      if (element) {
        window.scrollTo({
          top: elementPosition - 80,
          behavior: "smooth",
        });
      }
    },

    showProduct(id) {
      this.$router.push({ name: "ProductDetail", params: { id } });
    },
  },
};
</script>

<style scoped>
.home-page {
  color: #333;
  line-height: 1.6;
}
</style>
